export default "__VITE_ASSET__AgzPPvm7__"